import DaySeparateSalesStoreManagementPage from './DaySeparateSalesStoreManagementPage';

export default DaySeparateSalesStoreManagementPage;
